<div class="row g-5 g-md-6" data-test="tariff-overview">
  @for (item of selectedTariffs(); track $index) {
    @if (checkIfAdditionalCardIsVisible(item)) {
      <div class="col-md-12" [attr.data-test]="'tariff-container-' + item.category.toLowerCase() + '-' + item.tariffKey">
        <ng-container [ngTemplateOutlet]="tariffHeader" [ngTemplateOutletContext]="{ item: item }" />
        <div class="row mt-4" [attr.data-test]="'tariff-card-' + item.category.toLowerCase() + '-' + item.tariffKey">
          <ng-container [ngTemplateOutlet]="tariffCard" [ngTemplateOutletContext]="{ item: item }" />
          <div
            class="col-md-6 mt-sm-4 mt-md-0"
            [attr.data-test]="'tariff-additional-card-' + item.category.toLowerCase() + '-' + item.tariffKey"
          >
            <div
              translate="{{ cardCategoryTitleKeyPrefix() }}.{{ item.category.toLowerCase() }}"
              style="opacity: 0; pointer-events: none; display: none"
              aria-hidden="true"
            ></div>
            <mwe-tariff-card-additional-options
              [headlineReference]="headlineService.getHeadline(1)"
              [tariff]="item"
              [isReadOnly]="isReadOnly()"
              [isKundeWerden]="isKundeWerden()"
            />
            @if (showAllesSicherAlreadyAppliedInfoText(item.tariffOptionsSap)) {
              <mwe-infobox
                messageKey="tariff.additionalOptions.allesSicherAppliedInfoText"
                [textParams]="allesSicherTextParams()"
                class="d-block mt-3 mt-md-4"
              />
            }
          </div>
        </div>
      </div>
    } @else {
      <div class="col-md-6" [attr.data-test]="'tariff-container-' + item.category.toLowerCase() + '-' + item.tariffKey">
        <ng-container [ngTemplateOutlet]="tariffHeader" [ngTemplateOutletContext]="{ item: item }" />
        <div class="row mt-4" [attr.data-test]="'tariff-card-' + item.category.toLowerCase() + '-' + item.tariffKey">
          <ng-container [ngTemplateOutlet]="tariffCard" [ngTemplateOutletContext]="{ item: item }" />
        </div>
      </div>
    }
  }
</div>

<ng-template #tariffHeader let-item="item">
  <div class="row g-3" [attr.data-test]="'tariff-header-' + item.category.toLowerCase() + '-' + item.tariffKey">
    <mwe-product-icon [category]="item.category" size="md" [showText]="false" class="col-auto mt-4" />
    <div class="col">
      <mwe-headline
        [headlineLevelIncrement]="0"
        cssClass="mb-0"
        text="{{ cardCategoryTitleKeyPrefix() }}.{{ item.category.toLowerCase() }}"
      />
      <p
        class="text--legal"
        [attr.data-test]="'tariff-header-' + item.category.toLowerCase() + '-legal'"
        [translate]="'tariff.selectionCard.stromGas.title'"
      ></p>
    </div>
  </div>
</ng-template>

<ng-template #tariffCard let-item="item">
  <div [attr.data-test]="'tariff-card-' + item.category.toLowerCase() + '-' + item.tariffKey" class="col">
    <mwe-tariff-selection-card-store [hasActions]="!isStatusPage()" [isReadonly]="isReadOnly()" [tariff]="item">
      <div class="text-center">
        <a
          class="btn btn-link btn-link--dark-blue"
          [href]="getTariffPdfUrl(item.tariffKey)"
          target="_blank"
          translate="tariff.selectionCard.tariffPdfLink"
          [attr.aria-label]="'tariff.selectionCard.tariffPdfLinkAria' | translate: { name: item.priceIndication?.tarif?.tarifName }"
        ></a>
      </div>
    </mwe-tariff-selection-card-store>

    @if (!isReadOnly()) {
      <mwe-tariffs-selection-button [category]="item.category" [anlageId]="item.anlageId" class="d-block mt-3 mt-md-4" />
    }

    @if (item.priceIndication.rechtsText && !isReadOnly()) {
      <div class="mt-3">
        <mwe-infobox type="neutral">
          <mwe-expander [textCss]="' '" class="d-block mt-n4" [textKey]="item.priceIndication.rechtsText" />
        </mwe-infobox>
      </div>
    }
  </div>
</ng-template>
